import { Icon, Modal, Text } from "@modernatx/ui-kit-react";
import React from "react";

export interface ErrorModalProps {
  isVisible: boolean;
  setVisible: (visible: boolean) => void;
  title?: string | null;
  onDismiss?: () => void; // custom button click handler
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  isVisible,
  setVisible,
  title = "Oops, something went wrong.",
  onDismiss
}) => {
  const handleDismiss = onDismiss || (() => setVisible(false));
  const modalButtons = [{ label: "Dismiss", onClick: handleDismiss }];

  return (
    <Modal
      isOpen={isVisible}
      onDismiss={handleDismiss}
      buttons={modalButtons}
      size="sm"
    >
      <Icon color="color-system-red-700" icon="x-circle" size="xl" />
      <Text variant="h5" sx={{ mb: 1 }}>
        {title}
      </Text>
      <Text variant="body-1-regular">
        If the issue persists, please contact customer service at
        WeCare@modernatx.com or 1-866-MODERNA (1-866-663-3762).
      </Text>
    </Modal>
  );
};
